module.exports = __webpack_public_path__ + "img/key.bcd6d4d7.png";